import { Component, ViewChild, OnInit, OnDestroy, Input } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { SummaryTotalItem } from 'devextreme/ui/data_grid';
import { ActivatedRoute, Router } from '@angular/router';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { FastracColsService } from '@bds/services';
import { CommunicationService, nameof } from '@bds/core';
import { CarIdTransformService } from '@bds/helpers';
import { bdsGridModeType } from '@bds/components';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-rt-transit-time-cycle-customer-summary-report',
    templateUrl: './rt-transit-time-cycle-customer-summary-report.component.html',
    styleUrls: ['./rt-transit-time-cycle-customer-summary-report.component.css'],
})
export class RtTransitTimeCycleCustomerSummaryReportComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy
{
    public gridId = 103;
    public gridMode: bdsGridModeType = 'single';
    public gridSource: any;
    public selectedRowKeys: Array<number> = [];
    public controlNames: string[] = ['Trip Close Begin Date', 'Trip Close End Date'];

    public displayReport: boolean = false;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public gridColumnService: FastracColsService,
        public communicationService: CommunicationService,
        public carIdTransformService: CarIdTransformService,
        public reportService: RailtracReportsService,
        public pageService: PageService,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.pageService.setHeader('Transit Time By Cycle Customer Summary');
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    onGetReportClick(event: any) {
        this.displayReport = true;
        this.gridSource = new DataSource(
            this.reportService.CreateAspNetDatastore(
                ReportConstants.ReportDataApiCall,
                this.gridId.toString(),
                event.startDate,
                event.endDate,
            ),
        );
    }

    onCancelClick() {
        this.displayReport = false;
    }

    @ViewChild(FastracDxGridWrapperComponent) set wrapper(w: FastracDxGridWrapperComponent) {
        Promise.resolve().then(() =>
            w?.grid?.instance?.option('summary', { totalItems: this.summaryTotalItems }),
        );
    }

    private summaryTotalItems: SummaryTotalItem[] = [
        {
            column: 'no_of_trips',
            summaryType: 'sum',
            displayFormat: 'Totals: {0}',
            alignment: 'right',
        },
        {
            column: 'w_avg_loaded',
            showInColumn: 'avg_loaded',
            summaryType: 'min',
            valueFormat: '###0.##',
            displayFormat: 'Avg: {0}',
            alignment: 'right',
        },
        {
            column: 'w_avg_at_cust',
            showInColumn: 'avg_at_cust',
            summaryType: 'min',
            valueFormat: '###0.##',
            displayFormat: '{0}',
            alignment: 'right',
        },
        {
            column: 'w_avg_unloaded',
            showInColumn: 'avg_unloaded',
            summaryType: 'min',
            valueFormat: '###0.##',
            displayFormat: '{0}',
            alignment: 'right',
        },
        {
            column: 'w_avg_idle_days',
            showInColumn: 'avg_idle_days',
            summaryType: 'min',
            valueFormat: '###0.##',
            displayFormat: '{0}',
            alignment: 'right',
        },
        {
            column: 'w_total_days',
            showInColumn: 'total_days',
            summaryType: 'min',
            valueFormat: '###0.##',
            displayFormat: '{0}',
            alignment: 'right',
        },
        {
            column: 'w_cycle_days',
            showInColumn: 'cycle_days',
            summaryType: 'min',
            valueFormat: '###0.##',
            displayFormat: '{0}',
            alignment: 'right',
        },
    ];
}
